<!--Main Screen Popup-->
<div *ngIf="data.name == 'mainScreen'">
  <div class="matDialogTitle">
    <h1 mat-dialog-title>{{ 'Welcome to Stacks' | translate }}</h1>
    <span class="material-icons-outlined closeDialog" (click)="onNoClick()"> close </span>
  </div>

  <div mat-dialog-content>
    <iframe class="introVideo" src="https://www.youtube.com/embed/xsVTqzratPs" [title]="'YouTube video player' | translate" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    <h3>{{ 'Develop across all platforms' | translate }}</h3>
    <p>{{ 'Learn one way to build applications with Angular and reuse your code and abilities to build apps for any deployment target. For web, mobile web, native mobile and native desktop.' | translate }}</p>

    <h3>{{ 'Speed' | translate }} &amp; {{ 'Performance' | translate }}</h3>
    <p>{{ 'Achieve the maximum speed possible on the Web Platform today, and take it further, via Web Workers and server-side rendering. Angular puts you in control over scalability. Meet huge data requirements by building data models on RxJS, Immutable.js or another push-model.' | translate }}</p>

    <h3>{{ 'Incredible tooling' | translate }}</h3>
    <p>{{ 'Build features quickly with simple, declarative templates. Extend the template language with your own components and use a wide array of existing components. Get immediate Angular-specific help and feedback with nearly every IDE and editor. All this comes together so you can focus on building amazing apps rather than trying to make the code work.' | translate }}</p>
    
    <h3>{{ 'Loved by millions' | translate }}</h3>
    <p>{{ 'From prototype through global deployment, Angular delivers the productivity and scalable infrastructure that supports Google\'s largest applications.' | translate }}</p>
    
    <h3>{{ 'What is Angular?' | translate }}</h3>

    <p>{{ 'Angular is a platform that makes it easy to build applications with the web. Angular combines declarative templates, dependency injection, end to end tooling, and integrated best practices to solve development challenges. Angular empowers developers to build applications that live on the web, mobile, or the desktop' | translate }}</p>

    <h3>{{ 'Architecture overview' | translate }}</h3>

    <p>{{ 'Angular is a platform and framework for building client applications in HTML and TypeScript. Angular is itself written in TypeScript. It implements core and optional functionality as a set of TypeScript libraries that you import into your apps.' | translate }}</p>

    <p>{{ 'The basic building blocks of an Angular application are NgModules, which provide a compilation context for components. NgModules collect related code into functional sets; an Angular app is defined by a set of NgModules. An app always has at least a root module that enables bootstrapping, and typically has many more feature modules.' | translate }}</p>

    <p>{{ 'Components define views, which are sets of screen elements that Angular can choose among and modify according to your program logic and data. Every app has at least a root component.' | translate }}</p>

    <p>{{ 'Components use services, which provide specific functionality not directly related to views. Service providers can be injected into components as dependencies, making your code modular, reusable, and efficient.' | translate }}</p>

    <p>{{ 'Both components and services are simply classes, with decorators that mark their type and provide metadata that tells Angular how to use them.' | translate }}</p>

    <p>{{ 'The metadata for a component class associates it with a template that defines a view. A template combines ordinary HTML with Angular directives and binding markup that allow Angular to modify the HTML before rendering it for display.' | translate }}</p>

    <p>{{ 'The metadata for a service class provides the information Angular needs to make it availableto components through Dependency Injection (DI).' | translate }}</p>

    <p>{{ 'An app\'s components typically define many views, arranged hierarchically. Angular provides the Router service to help you define navigation paths among views. The router provides sophisticated in-browser navigational capabilities.' | translate }}</p>
  </div>
  <!--Restricted Page Popup-->
</div>
<div *ngIf="data.name == 'restrictedPage'">
  <div class="restrictedPage">
    <div class="matDialogTitle titleWrapper">
      <h1 mat-dialog-title class="subH1">
        {{ this.SubscriptionFlow.package?.type === 'Starter' ? 'Your current plan doesn't support this feature. Upgrade to enjoy full access!' : ('This package is unsupported. Subscribe now to enjoy all features!' | translate) }}
      </h1>
    </div>

    <div mat-dialog-content class="contentWrapper">
      <img src="assets/images/restricted_page.png" alt="" />
      <button [routerLink]="['/billing']" (click)="closeDialog('restrictedPage')" class="stacksBtn blue subBtn">
        {{ this.SubscriptionFlow.package?.type === 'Starter' ? 'Upgrade now' : ('Subscribe now' | translate) }}
      </button>
    </div>
  </div>
</div>
<!--Subscription Status Popup-->
<div *ngIf="data.name == 'subscriptionStatus'">
  <div class="mainWrapper">
    <div
      class="bgImg"
      [ngClass]="{
        bgImgOnhold: this.projectData.status === 'onhold',
        bgImgCancelled: this.projectData.status === 'cancelled'
      }"
    ></div>
    <div class="headerWrapper">
      <div
        class="statusImg"
        [ngClass]="{
          statusImgOnhold: this.projectData.status === 'onhold',
          statusImgCancelled: this.projectData.status === 'cancelled'
        }"
      >
        <img *ngIf="this.SubscriptionFlow.package?.type === 'Starter'" src="./assets/images/subscriptionFlow/starter-inner-icon.png" />
        <img *ngIf="this.SubscriptionFlow.package?.type === 'Growth'" src="./assets/images/subscriptionFlow/growth-inner-icon.png" />
      </div>
      <div class="details">
        <h1>{{ this.SubscriptionFlow.package?.type }}</h1>
        <h3 *ngIf="this.projectData.status === 'active'">{{ 'Your Subscription Plan' | translate }}</h3>
        <h3 *ngIf="this.projectData.status === 'onhold'" class="inActiveText">{{ 'Your Subscription is on hold' | translate }}</h3>
        <h3 *ngIf="this.projectData.status === 'cancelled'" class="inActiveText">{{ 'Your Subscription has been cancelled' | translate }}</h3>
      </div>
      <div
        class="statusInput"
        [ngClass]="{
          statusInputOnhold: this.projectData.status === 'onhold',
          statusInputCancelled: this.projectData.status === 'cancelled'
        }"
      >
        <h2>{{ this.projectData.status }}</h2>
      </div>
    </div>

    <div class="mainContent">
      <div class="leftSection">
        <h1 id="leftH1">{{ 'Included in your plan' | translate }}</h1>
        <ul [ngClass]="showMore ? 'expanded' : 'collapsed'">
          <li *ngFor="let feature of this.displayedFeatures">{{ feature.name }}</li>
          <div *ngIf="showMore">
            <li *ngFor="let feature of this.hiddenFeatures">{{ feature.name }}</li>
          </div>
        </ul>
      </div>
      <div class="rightSection">
        <h1 id="rightH1">{{ 'Billing and payment' | translate }}</h1>
        <div class="billingDataUp">
          <span class="material-icons">credit_card</span>
          <p *ngIf="this.SubscriptionFlow.stripe?.payment_methods?.card?.last4">MasterCard ending ****{{ this.SubscriptionFlow.stripe?.payment_methods?.card?.last4 }}</p>
          <p *ngIf="!this.SubscriptionFlow.stripe?.payment_methods">{{ 'No payment methods available.' | translate }}</p>
        </div>
        <div class="billingDataDown">
          <span class="material-icons">calendar_today</span>
          <div class="paymentDetails">
            <p>{{ this.SubscriptionFlow.package?.name }} {{ this.SubscriptionFlow.package?.price }} {{ this.SubscriptionFlow.package?.period }}</p>
            <p *ngIf="this.SubscriptionFlow.stripe?.upcoming_invoice?.next_payment_attempt" id="nxtPaymentDetails">
              {{ 'Next payment on' | translate }} {{ this.SubscriptionFlow.stripe?.upcoming_invoice?.next_payment_attempt * 1000 | date: 'MMMM d, y' }} {{ 'Annual plan, paid' | translate }} {{ this.SubscriptionFlow.package.period }}
            </p>
            <p *ngIf="!this.SubscriptionFlow.stripe?.upcoming_invoice?.next_payment_attempt" id="nxtPaymentDetails">{{ 'No scheduled payment.' | translate }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <p (click)="toggleFeatures()">
        {{ showMore ? 'Show Less' : 'Show More' }}
      </p>

      <span *ngIf="this.projectData.status != 'cancelled'" [routerLink]="['/billing']" (click)="closeDialog('subscriptionStatus')"><p>{{ 'Manage Plan' | translate }}</p></span>
      <span *ngIf="this.projectData.status === 'cancelled'" (click)="reactivateSubscription()"><p>{{ 'Reactivate Subscription' | translate }}</p></span>
    </div>
  </div>
</div>

<div *ngIf="data.name == 'successPayment'">
  <div class="mainWrapperSuccessPayment">
    <div class="headerWrapper"></div>
    <div class="contentWrapper">
      <div class="imgWrapper">
        <img *ngIf="newPackage.type === 'Starter'" src="../assets/images/subscriptionFlow/starter-inner-icon.png" />
        <img *ngIf="newPackage.type === 'Growth'" src="../assets/images/subscriptionFlow/growth-inner-icon.png" />
      </div>
      <h2>{{ 'You have successfully subscribed to Package' | translate }}</h2>
      <span>🎉</span>
      <p>Stacks Plans - {{ newPackage.type }} - {{ newPackage.duration }} Plan</p>
    </div>
  </div>
</div>
<div *ngIf="data.name == 'appPreview'">
  <div class="matDialogTitle">
    <h1 mat-dialog-title>{{ 'Real preview for your application' | translate }}</h1>
    <span class="material-icons-outlined closeDialog" (click)="onNoClick()"> close </span>
  </div>

  <div mat-dialog-content>
    <iframe class="introVideo" src="https://www.youtube.com/embed/5U14MWNiFqw" [title]="'YouTube video player' | translate" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    <h3>{{ 'Preview the App on real Devices' | translate }}</h3>
    <p>{{ 'After you have generated an application, you can test it live to see the reflection of each and every action you take and enjoy.' | translate }}</p>
    <h3>{{ 'Real Time changes' | translate }}</h3>
    <p>{{ 'Once you go to the builder and make your changes you can click on Update button and get back here to see how your changes will look like in real application' | translate }}</p>
  </div>
</div>

<div *ngIf="data.name == 'onboardingFeedback'">
  <div class="ratingWrapper" mat-dialog-content>
    <h1 class="experience">{{ 'How do you rate your onboarding experience?' | translate }}</h1>
    <app-star-rating></app-star-rating>
    <textarea id="w3review" name="w3review" rows="4" cols="50" [placeholder]="'Leave a comment' | translate" #commentInput></textarea>
    <div class="buttonContainer">
      <button (click)="submitFeedback(commentInput.value)" class="Send">{{ 'Send' | translate }}</button>
    </div>
  </div>
</div>

<div *ngIf="data.name == 'onboardingOffer'">
  <div class="ratingWrapper" mat-dialog-content>
    <h1 class="experience">
      {{ 'Claim Offer now and let\'s help you' | translate }} <br />
      {{ 'increase your revenue' | translate }}
    </h1>

    <ul>
      <li>
        <img src="assets/images/popups/lifetime.png" />
        <span
          >{{ 'Limited' | translate }} <br />
          {{ 'Lifetime Offer' | translate }}</span
        >
      </li>
      <li>
        <img src="assets/images/popups/design_app.png" />
        <span
          >{{ 'We will' | translate }} <br />
          {{ 'design for you' | translate }}</span
        >
      </li>
      <li>
        <img src="assets/images/popups/app-upload.png" />
        <span
          >{{ 'Upload to Google' | translate }} <br />
          {{ ' & App Stores' | translate }}</span
        >
      </li>
    </ul>
    <div class="buttonContainer">
      <button class="stacksBtn green" (click)="closeDialog('onboardingOffer')">{{ 'Skip' | translate }}</button>
      <button (click)="claimOffer('onboardingOffer')" class="Send">{{ 'Claim Offer' | translate }}</button>
    </div>
  </div>
</div>

<div *ngIf="data.name == 'globals'">
  <div class="matDialogTitle">
    <h1 mat-dialog-title>{{ 'Play with your App fonts' | translate }}</h1>
    <span class="material-icons-outlined closeDialog" (click)="onNoClick()"> close </span>
  </div>

  <div mat-dialog-content>
    <iframe class="introVideo" src="https://www.youtube.com/embed/Bz0we5EUcRs" [title]="'YouTube video player' | translate" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    <p>{{ 'Stacks Builder has more than 1000+ google fonts, to make it easy to bring personality and performance to your Application and products You can also create your own highly customized collections by filtering fonts, plus changing their color, and reviewing them. so you can choose, customize and match your brand identity' | translate }}</p>
    <p>{{ 'All you need to do is:' | translate }}</p>
    <p>{{ 'Choose the font you would like to use in your application (the font you choose will apply in all the pages of application), from the drop down menu' | translate }}</p>
    <img class="dialogImg" src="https://builder.stacksmarket.co/wp-content/uploads/2022/01/branding.gif" alt="" />
    <p>{{ 'Adjust the font size' | translate }}</p>
    <img class="dialogImg" src="https://builder.stacksmarket.co/wp-content/uploads/2022/01/branding2.gif" alt="" />

    <p>{{ 'You can also change the global header and footer from here' | translate }}</p>
  </div>
</div>
<div *ngIf="data.name == 'connectivity'">
  <div class="matDialogTitle">
    <h1 mat-dialog-title>{{ 'connects your website with Stacks builder.' | translate }}</h1>
    <span class="material-icons-outlined closeDialog" (click)="onNoClick()"> close </span>
  </div>

  <div mat-dialog-content>
    <!-- <iframe class="introVideo" src="https://www.youtube.com/embed/Bz0we5EUcRs" [title]="'YouTube video player' | translate" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->
    <p>{{ 'Download our latest plugin & add it to your WordPress website to easily integrate with Stacks builder. Once you add our plugin to your website, your products, categories & posts will be auto-synced to the application. And when you receive any order from the application, it will be automatically added to your website dashboard.' | translate }}</p>
    <p>{{ 'Please make sure that the site you're connecting with is:' | translate }}</p>
    <p>{{ 'Your server is connected to a domain and not an IP address.' | translate }}</p>
    <p>{{ 'https:// not http://' | translate }}</p>
    <p>{{ 'Make sure Stacks plugin is active in your WordPress website.' | translate }}</p>
    <img class="dialogImg" src="https://builder.stacksmarket.co/wp-content/uploads/2022/01/connectivity.png" alt="" />
    <p>{{ 'If you received any connectivity error, please proceed with these troubleshooting steps.' | translate }}</p>
    <p>{{ 'This URL should work: yourwebsite.com/wp-json' | translate }}</p>
    <p>{{ 'For multisite, if the URL is yourwebsite.com/ar then the API path will still be the same: yourwebsite.com/wp-json' | translate }}</p>
  </div>
</div>

<div *ngIf="data.name == 'pushNotifications'" class="pn-dialog">

  <!-- Header -->
  <div class="pn-dialog-header">
    <div class="pn-dialog-title-group">
      <div class="pn-dialog-icon">
        <span class="material-icons-outlined">notifications_active</span>
      </div>
      <div class="pn-dialog-title-text">
        <h2>{{ 'Set up Push Notifications' | translate }}</h2>
        <p>{{ 'Reach your customers directly on their devices' | translate }}</p>
      </div>
    </div>
    <button class="pn-dialog-close" (click)="onNoClick()">
      <span class="material-icons-outlined">close</span>
    </button>
  </div>

  <!-- Scrollable body -->
  <div mat-dialog-content class="pn-dialog-body">

    <!-- Video -->
    <div class="pn-video-wrapper">
      <iframe src="https://www.youtube.com/embed/nHFT8Ufr9fI" title="Push Notifications Setup" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>

    <!-- Steps -->
    <div class="pn-steps">

      <div class="pn-step">
        <div class="pn-step-number">1</div>
        <div class="pn-step-content">
          <h4>{{ 'Connect Firebase' | translate }}</h4>
          <p>{{ 'Follow the Firebase setup guide and connect your project using the Service Keys and config files.' | translate }}</p>
        </div>
      </div>

      <div class="pn-step">
        <div class="pn-step-number">2</div>
        <div class="pn-step-content">
          <h4>{{ 'Select Your Audience' | translate }}</h4>
          <p>{{ 'Reach all users at once or target a specific customer from the user list below.' | translate }}</p>
        </div>
      </div>

      <div class="pn-step">
        <div class="pn-step-number">3</div>
        <div class="pn-step-content">
          <h4>{{ 'Compose Your Message' | translate }}</h4>
          <p>{{ 'Write a clear notification title and message. Add emojis to boost engagement!' | translate }}</p>
        </div>
      </div>

      <div class="pn-step">
        <div class="pn-step-number">4</div>
        <div class="pn-step-content">
          <h4>{{ 'Send & Engage' | translate }}</h4>
          <p>{{ 'Hit Send and bring users back to your app with targeted, timely push notifications.' | translate }}</p>
        </div>
      </div>

    </div>

  </div>

  <!-- Footer — outside scroll area so it's always visible -->
  <div class="pn-dialog-footer">
    <button class="pn-got-it-btn" (click)="onNoClick()">{{ 'Got it' | translate }}</button>
  </div>

</div>
<div *ngIf="data.name == 'messageSentAndroid'">
  <div class="matDialogTitle closeMessage">
    <span class="material-icons-outlined closeDialog" (click)="onNoClick()"> close </span>
  </div>

  <div mat-dialog-content class="messageWrapper">
    <div class="gifWrapper">
      <img *ngIf="!gifRemoved" id="gif" class="messageSentGif" src="assets/gifs/new gifs/check.gif" alt="" />
      <img *ngIf="gifRemoved" id="gif" class="messageSentGif gifToImage" src="assets/images/popups/check.webp" alt="" />
    </div>
    <h3>{{ 'Message Sent to Android Devices Successfully' | translate }}</h3>
  </div>
</div>

<div *ngIf="data.name == 'messageSentIOS'">
  <div class="matDialogTitle closeMessage">
    <span class="material-icons-outlined closeDialog" (click)="onNoClick()"> close </span>
  </div>

  <div mat-dialog-content class="messageWrapper">
    <div class="gifWrapper">
      <img *ngIf="!gifRemoved" id="gif" class="messageSentGif" src="assets/gifs/new gifs/check.gif" alt="" />
      <img *ngIf="gifRemoved" id="gif" class="messageSentGif gifToImage" src="assets/images/popups/check.webp" alt="" />
    </div>
    <h3>{{ 'Message Sent to IOS Devices Successfully' | translate }}</h3>
  </div>
</div>

<div *ngIf="data.name == 'templates'">
  <div class="matDialogTitle">
    <h1 mat-dialog-title>{{ 'A wide variety of templates to facilitate your designing experience' | translate }}</h1>
    <span class="material-icons-outlined closeDialog" (click)="onNoClick()"> close </span>
  </div>

  <div mat-dialog-content>
    <p>{{ 'Stacks is trying to make it easy for you so we made templates you can choose from them any design that inspires you or start from scratch and choose the blanked one, add and drop anything anywhere so you will make your dreamed design be real' | translate }}</p>
  </div>
</div>
<div *ngIf="data.name == 'android'">
  <div class="matDialogTitle">
    <h1 mat-dialog-title>{{ 'Build your Android application whether its APK or AAB' | translate }}</h1>
    <span class="material-icons-outlined closeDialog" (click)="onNoClick()"> close </span>
  </div>

  <div mat-dialog-content>
    <iframe class="introVideo" src="https://www.youtube.com/embed/WrBt-GDjCZ0" [title]="'YouTube video player' | translate" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    <p>{{ 'Before you start generating your app, you will need to enter your version number (1.1 for example).' | translate }}</p>
    <p>{{ 'After you have entered your version number you have to click on generate application at the top and wait a couple of minutes for your application to be generated.' | translate }}</p>
    <p>{{ 'Once your application is ready, you will have to choose between downloading an APK or AAB file. The APK file is used to review your app on Android devices, but in order to upload your app to Google Play, you need to choose the AAB file.' | translate }}</p>
  </div>
</div>

<div *ngIf="data.name == 'ios'">
  <div class="matDialogTitle">
    <h1 mat-dialog-title>{{ 'Generate your Application and upload it automatically to appstore' | translate }}</h1>
    <span class="material-icons-outlined closeDialog" (click)="onNoClick()"> close </span>
  </div>

  <div mat-dialog-content>
    <iframe class="introVideo" src="https://www.youtube.com/embed/Zfcz8otrcfI" [title]="'YouTube video player' | translate" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    <p>{{ 'In order to view your IOS Application, you need an Itunes developer account' | translate }}</p>
    <p>{{ 'For Apple, you will first need to create a developer account from the following link: https://appstoreconnect.apple.com/' | translate }}</p>
    <p>{{ 'When you connect your developer account with Stacks Builder, you will be able to upload the IPA file of your app to the App Store and follow the step-by-step video guide to build your mobile application and generate the IPA file.' | translate }}</p>
  </div>
</div>
<div *ngIf="data.name == 'templateLocked'">
  <div class="matDialogTitle">
    <h1 mat-dialog-title>{{ 'Upgrade to unlock' | translate }}</h1>
  </div>

  <div mat-dialog-content>
    <p>{{ 'Sorry this template is locked for premium subscriptions only, consider upgrading or choose a free template' | translate }}</p>
    <a href="#" class="stacksBtn green">{{ 'Subscribe Now' | translate }}</a>
  </div>
</div>

<div *ngIf="data.name == 'viewLocked'">
  <div class="matDialogTitle">
    <h1 mat-dialog-title>{{ 'Upgrade to unlock' | translate }}</h1>
  </div>

  <div mat-dialog-content>
    <p>{{ 'Sorry this view is locked for premium subscriptions only' | translate }}</p>
    <a href="#" class="stacksBtn green">{{ 'Subscribe Now' | translate }}</a>
  </div>
</div>

<div class="checklist" *ngIf="data.name == 'customizeDesign'">
  <div class="matDialogTitle">
    <h1 mat-dialog-title>{{ 'Add Block & Customize Design' | translate }}</h1>
    <span class="material-icons-outlined closeDialog" (click)="onNoClick()"> close </span>
  </div>

  <div mat-dialog-content>
    <h2 class="first">{{ 'Add Block' | translate }}</h2>
    <p>{{ 'Click on any block to add it to your design.' | translate }}</p>
    <img class="dialogImg" src="assets/images/checklist/Add_Blocks.gif" alt="" />

    <h2>{{ 'Relocate Blocks' | translate }}</h2>
    <p>{{ 'Once the block is added, you can drag it and relocate it wherever you want.' | translate }}</p>
    <img src="assets/images/checklist/dragBlocks.gif" alt="" />

    <h2>{{ 'Edit Block' | translate }}</h2>
    <p>{{ 'If you click on Edit, you can customize the content and style of the block.' | translate }}</p>
    <img src="assets/images/checklist/Customize_Design.gif" alt="" />

    <div class="buttonWrapper">
      <button (click)="completeTour(0)">{{ 'Done' | translate }}</button>
    </div>
  </div>
</div>
<div class="checklist" *ngIf="data.name == 'addViews'">
  <div class="matDialogTitle">
    <h1 mat-dialog-title>{{ 'Customize & Add Views' | translate }}</h1>
    <span class="material-icons-outlined closeDialog" (click)="onNoClick()"> close </span>
  </div>

  <div mat-dialog-content>
    <h2 class="first">{{ 'Choose View' | translate }}</h2>
    <p>{{ 'You can customize any view of the application and redesign it the same way you designed the home page from the Views Editor' | translate }}</p>
    <img class="dialogImg" src="assets/images/checklist/choose_view_to_edit.gif" alt="" />

    <h2>{{ 'Views Default Blocks' | translate }}</h2>
    <p>{{ "The blurred sections are default blocks that can't be removed from views. For example, you can't remove the product name from the product page, but you can add more blocks to the page and change the order of the blocks." | translate }}</p>
    <img src="assets/images/checklist/blured_block.gif" alt="" />

    <h2>{{ 'Customize View' | translate }}</h2>
    <p>{{ 'You can add unlimited views to serve different purposes (offers, sign-ups, updates, etc.) and connect pages using the Bottom Block or Image Block' | translate }}</p>
    <img src="assets/images/checklist/add_view.gif" alt="" />

    <div class="buttonWrapper">
      <button (click)="completeTour(1)">{{ 'Done' | translate }}</button>
    </div>
  </div>
</div>
<div class="checklist" *ngIf="data.name == 'previewChanges'">
  <div class="matDialogTitle">
    <h1 mat-dialog-title>{{ 'Preview Changes' | translate }}</h1>
    <span class="material-icons-outlined closeDialog" (click)="onNoClick()"> close </span>
  </div>

  <div mat-dialog-content>
    <p class="first">{{ 'After you change the design click Update to save changes and go to Preview App to experience your design' | translate }}</p>
    <img class="dialogImg" src="assets/images/checklist/perview.gif" alt="" />

    <div class="buttonWrapper">
      <button (click)="completeTour(2)">{{ 'Done' | translate }}</button>
    </div>
  </div>
</div>
<div class="checklist" *ngIf="data.name == 'bookDemo'">
  <div class="matDialogTitle">
    <h1 mat-dialog-title>{{ 'Book a Demo' | translate }}</h1>
    <span class="material-icons-outlined closeDialog" (click)="onNoClick()"> close </span>
  </div>

  <div mat-dialog-content>
    <p class="first">{{ 'If you need help with the design or need to get answers to all your questions, you can go to the demo tab and book a suitable date to meet with one of our experts' | translate }}</p>
    <div class="buttonWrapper">
      <button [routerLink]="['help']" (click)="completeTour(3)">{{ 'Book A Demo Call' | translate }}</button>
    </div>
  </div>
</div>
<div class="checklist" *ngIf="data.name == 'addProduct'">
  <div class="matDialogTitle">
    <h1 mat-dialog-title>{{ 'Add Products (Connect Site)' | translate }}</h1>
    <span class="material-icons-outlined closeDialog" (click)="onNoClick()"> close </span>
  </div>

  <div mat-dialog-content>
    <p class="first">{{ 'Stacks is integrated with WooCommerce to auto-sync products and categories from your website.' | translate }}</p>
    <p>{{ 'To get started go to the Connectivity tab -> Download and activate the plugin from WordPress.org -> add your website URL -> Connect' | translate }}</p>
    <p>{{ 'Once connected, add the products and categories block and you will find all your products are synced from your website' | translate }}</p>
    <img class="dialogImg" src="assets/images/checklist/add_product.gif" alt="" />

    <div class="buttonWrapper">
      <button (click)="completeTour(4)">{{ 'Done' | translate }}</button>
    </div>
  </div>
</div>
<div class="checklist" *ngIf="data.name == 'generateApp'">
  <div class="matDialogTitle">
    <h1 mat-dialog-title>{{ 'Generate-App-(Android-IOS)' | translate }}</h1>
    <span class="material-icons-outlined closeDialog" (click)="onNoClick()"> close </span>
  </div>

  <div mat-dialog-content>
    <p class="first">{{ 'Now that your App is ready to be live, you can generate the application and try it on your phone or send it to a few of your network to try it out' | translate }}</p>

    <p>{{ 'Go to Android or IOS, Enter the App version, and click generate' | translate }}</p>

    <p>{{ '(For IOS you need to connect iTunes account first)' | translate }}</p>

    <img src="assets/images/checklist/app_name_and_build.gif" alt="" />

    <div class="buttonWrapper">
      <button (click)="completeTour(5)">{{ 'Done' | translate }}</button>
    </div>
  </div>
</div>
<div class="checklist" *ngIf="data.name == 'sendPush'">
  <div class="matDialogTitle">
    <h1 mat-dialog-title>{{ 'Send Push Notification' | translate }}</h1>
    <span class="material-icons-outlined closeDialog" (click)="onNoClick()"> close </span>
  </div>

  <div mat-dialog-content>
    <p class="first">{{ 'Since you have the App on your phone, sign up and try to send yourself a push Notification' | translate }}</p>

    <p>
      {{ 'Connect Firebase following' | translate }} <a class="guideLink" href="https://stacksmarket.co/knowledge-base/activate-push-notifications-on-your-mobile-application/"> {{ 'guide' | translate }} </a>
    </p>

    <p>{{ 'Go to the Push Notification tab, select users, type your message, and click Send' | translate }}</p>

    <img src="assets/images/checklist/push_notification.gif" alt="" />

    <div class="buttonWrapper">
      <button (click)="completeTour(6)">{{ 'Done' | translate }}</button>
    </div>
  </div>
</div>
<div class="checklist" *ngIf="data.name == 'uploadApp'">
  <div class="matDialogTitle">
    <h1 mat-dialog-title>{{ 'Upload App' | translate }}</h1>
    <span class="material-icons-outlined closeDialog" (click)="onNoClick()"> close </span>
  </div>

  <div mat-dialog-content>
    <p class="first">{{ 'Everything is now ready to go live!' | translate }}</p>

    <p>{{ 'Follow these guides to publish your app on the App Store & Play Store' | translate }}</p>

    <a href="https://stacksmarket.co/knowledge-base/apple-build-guide/" target="_blank">{{ 'IOS' | translate }}</a>

    <a href="https://support.google.com/googleplay/android-developer/answer/9859152?hl=en" target="_blank">{{ 'Android' | translate }}</a>

    <div class="buttonWrapper">
      <button (click)="completeTour(7)">{{ 'Done' | translate }}</button>
    </div>
  </div>
</div>
<div *ngIf="data.name == 'tourCompleted'">
  <div class="matDialogTitle">
    <h1 mat-dialog-title>{{ 'Congratulations, Tour Completed Successfully' | translate }}</h1>
    <span class="material-icons-outlined closeDialog" (click)="onNoClick()"> close </span>
  </div>

  <div mat-dialog-content>
    <img src="assets/images/tourDone.png" />
    <h1>{{ 'Now you know all the basic views needed, we will open all the views for you to check' | translate }}</h1>
    <p>{{ 'Need help? Send us a message and we will be happy to support you in your journey' | translate }}</p>
  </div>
</div>
<!--Analytics dialog to fill the firebase settings-->
<div *ngIf="data.name == 'analytics'">
  <div class="matDialogTitle" id="analytics">
    <h1 mat-dialog-title>{{ 'Please fill in the missing Firebase settings.' | translate }}</h1>
    <span class="material-icons-outlined closeDialog" (click)="onNoClick()"> close </span>
  </div>

  <div class="analyticsWrapper" mat-dialog-content>
    <p>{{ 'To access the analytics page, you need to provide your Firebase settings.' | translate }}</p>
    <div class="btnWrapper">
      <button id="analyticsBtn" (click)="onNoClick()" [routerLink]="['/firebasesettings']">{{ 'Go to Firebase settings' | translate }}</button>
    </div>
  </div>
</div>

<!-- Fincart -->
<div *ngIf="data?.name === 'fincartConfirm' && fincartData">
  <div class="matDialogTitle">
  <h2 mat-dialog-title>{{ fincartData.title }}</h2>
  </div>

  <mat-dialog-content>
    <p>
      {{ 'Fincart shipping cost for' | translate }}
      <strong>{{ fincartData.governorate }}</strong>:
      <strong>{{ fincartData.price }} {{ 'EGP' | translate }}</strong>
    </p>

    <p class="mt-2">
      {{ 'This amount will be deducted automatically from the order.' | translate }}
    </p>

    <p class="mt-2">
      {{ 'Do you want to proceed?' | translate }}
    </p>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="btnWrapper">
    <button mat-button (click)="cancel()">{{ 'Cancel' | translate }}</button>
    <button mat-raised-button color="primary" (click)="confirm()">{{ 'Proceed' | translate }}</button>
  </mat-dialog-actions>
</div>
